// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"5731f2a1","361":"3c789fd9"}[chunkId] + ".chunk.js";
};